import { render, staticRenderFns } from "./CommentsModule.vue?vue&type=template&id=0dadfb54&scoped=true"
import script from "./CommentsModule.vue?vue&type=script&lang=js"
export * from "./CommentsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dadfb54",
  null
  
)

export default component.exports